import { ɵɵinject, ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, Inject, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, ɵɵadvance, ɵɵtextInterpolate1, ɵɵdirectiveInject, ɵɵdefineComponent, ɵɵviewQuery, ɵɵqueryRefresh, ɵɵloadQuery, ɵɵlistener, ɵɵtemplate, ɵɵproperty, Component, ViewChild, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { filter, findLast } from 'lodash';
import { Subject } from 'rxjs';
import { NgForOf, CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserModule } from '@angular/platform-browser';
import { DefaultLayoutDirective, DefaultLayoutGapDirective, DefaultLayoutAlignDirective } from '@angular/flex-layout/flex';
import { MatSlideToggle, MatSlideToggleModule } from '@angular/material/slide-toggle';

class LoggingModuleOptions {
}
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["TRACE"] = 0] = "TRACE";
    LogLevel[LogLevel["DEBUG"] = 1] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
})(LogLevel || (LogLevel = {}));
class SyncLogMessage {
    constructor(message) {
        this.message = message;
    }
}
class TraceSyncLogMessage extends SyncLogMessage {
    constructor(message) {
        super(message);
        this.logLevel = LogLevel.TRACE;
    }
}
class DebugSyncLogMessage extends SyncLogMessage {
    constructor(message) {
        super(message);
        this.logLevel = LogLevel.DEBUG;
    }
}
class InfoSyncLogMessage extends SyncLogMessage {
    constructor(message) {
        super(message);
        this.logLevel = LogLevel.INFO;
    }
}
class WarnSyncLogMessage extends SyncLogMessage {
    constructor(message) {
        super(message);
        this.logLevel = LogLevel.WARN;
    }
}
class ErrorSyncLogMessage extends SyncLogMessage {
    constructor(error, message) {
        super(message);
        this.logLevel = LogLevel.ERROR;
        this.error = error;
    }
}

class SyncLoggingService {
    constructor(options) {
        this.fullLog = [];
        this.logSubject = new Subject();
        this.logLevel = options.logLevel;
    }
    get log() {
        return filter(this.fullLog, (msg) => msg.logLevel >= this.logLevel);
    }
    get tail() {
        return findLast(this.fullLog, (msg) => msg.logLevel === LogLevel.INFO);
    }
    get logStream() {
        return this.logSubject.asObservable();
    }
    trace(message) {
        this.next(new TraceSyncLogMessage(message));
    }
    debug(message) {
        this.next(new DebugSyncLogMessage(message));
    }
    info(message) {
        this.next(new InfoSyncLogMessage(message));
    }
    warn(message) {
        this.next(new WarnSyncLogMessage(message));
    }
    error(error, message) {
        this.next(new ErrorSyncLogMessage(error, message));
    }
    clear() {
        this.fullLog = [];
    }
    next(message) {
        this.fullLog.push(message);
        this.logSubject.next(message);
    }
}
SyncLoggingService.ɵfac = function SyncLoggingService_Factory(t) { return new (t || SyncLoggingService)(ɵɵinject(LoggingModuleOptions)); };
SyncLoggingService.ɵprov = ɵɵdefineInjectable({ token: SyncLoggingService, factory: SyncLoggingService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(SyncLoggingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: LoggingModuleOptions, decorators: [{
                type: Inject,
                args: [LoggingModuleOptions]
            }] }]; }, null); })();

class SyncLoggingServiceStub {
    constructor() {
        this.log = [];
        this.tail = { message: '' };
    }
    trace(message) { }
    debug(message) { }
    info(message) { }
    warn(message) { }
    error(error, message) { }
    clear() { }
}

const _c0 = ["logContainer"];
function SyncLogComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 8);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const message_r2 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1("\n        ", message_r2.message, "\n      ");
} }
class SyncLogComponent {
    constructor(syncLog) {
        this.syncLog = syncLog;
        this.showDetails = false;
    }
    ngAfterViewInit() {
        this.observer = new MutationObserver(mutations => {
            this.logContainer.nativeElement.scrollTop = this.logContainer.nativeElement.scrollHeight;
        });
        this.observer.observe(this.logContainer.nativeElement, { childList: true });
    }
    ngOnDestroy() {
        this.observer.disconnect();
    }
    toggleDetails() {
        this.showDetails = !this.showDetails;
        setTimeout(() => (this.logContainer.nativeElement.scrollTop = this.logContainer.nativeElement.scrollHeight));
    }
}
SyncLogComponent.ɵfac = function SyncLogComponent_Factory(t) { return new (t || SyncLogComponent)(ɵɵdirectiveInject(SyncLoggingService)); };
SyncLogComponent.ɵcmp = ɵɵdefineComponent({ type: SyncLogComponent, selectors: [["ff-sync-log"]], viewQuery: function SyncLogComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0, 3);
    } if (rf & 2) {
        let _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.logContainer = _t.first);
    } }, decls: 12, vars: 3, consts: [["fxLayout", "column", "fxLayoutGap", "8px"], ["fxLayout", "row", "fxLayoutAlign", "end"], [3, "change"], ["fxLayout", "column"], [3, "hidden"], ["fxLayout", "column", 1, "log-container", "detail-view"], ["logContainer", ""], ["class", "log-message", 4, "ngFor", "ngForOf"], [1, "log-message"]], template: function SyncLogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "mat-slide-toggle", 2);
        ɵɵlistener("change", function SyncLogComponent_Template_mat_slide_toggle_change_2_listener() { return ctx.toggleDetails(); });
        ɵɵtext(3, "Details");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(4, "div", 3);
        ɵɵtext(5);
        ɵɵelementEnd();
        ɵɵelementStart(6, "div", 4);
        ɵɵelementStart(7, "pre", 5, 6);
        ɵɵtext(9, "      ");
        ɵɵtemplate(10, SyncLogComponent_div_10_Template, 2, 1, "div", 7);
        ɵɵtext(11, "\n    ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(5);
        ɵɵtextInterpolate1(" ", ctx.syncLog.tail ? ctx.syncLog.tail.message : "", " ");
        ɵɵadvance(1);
        ɵɵproperty("hidden", !ctx.showDetails);
        ɵɵadvance(4);
        ɵɵproperty("ngForOf", ctx.syncLog.log);
    } }, directives: [DefaultLayoutDirective, DefaultLayoutGapDirective, DefaultLayoutAlignDirective, MatSlideToggle, NgForOf], styles: ["[_nghost-%COMP%]   .log-container[_ngcontent-%COMP%]{height:24px;width:100%}[_nghost-%COMP%]   .log-container.detail-view[_ngcontent-%COMP%]{height:200px;overflow:scroll}[_nghost-%COMP%]   .log-container.detail-view[_ngcontent-%COMP%]   .log-message[_ngcontent-%COMP%]{margin-bottom:2px;white-space:nowrap}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(SyncLogComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line: component-selector
                selector: 'ff-sync-log',
                templateUrl: './sync-log.component.html',
                styleUrls: ['./sync-log.component.scss'],
            }]
    }], function () { return [{ type: SyncLoggingService }]; }, { logContainer: [{
            type: ViewChild,
            args: ['logContainer', { static: true }]
        }] }); })();

class LoggingModule {
    static forRoot(options) {
        return {
            ngModule: LoggingModule,
            providers: [
                {
                    provide: LoggingModuleOptions,
                    useValue: options
                }
            ]
        };
    }
}
LoggingModule.ɵmod = ɵɵdefineNgModule({ type: LoggingModule });
LoggingModule.ɵinj = ɵɵdefineInjector({ factory: function LoggingModule_Factory(t) { return new (t || LoggingModule)(); }, imports: [[
            CommonModule,
            MatSlideToggleModule,
            BrowserModule,
            FlexLayoutModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(LoggingModule, { declarations: [SyncLogComponent], imports: [CommonModule,
        MatSlideToggleModule,
        BrowserModule,
        FlexLayoutModule], exports: [SyncLogComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(LoggingModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatSlideToggleModule,
                    BrowserModule,
                    FlexLayoutModule
                ],
                declarations: [SyncLogComponent],
                exports: [SyncLogComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of fitforce-logging
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DebugSyncLogMessage, ErrorSyncLogMessage, InfoSyncLogMessage, LogLevel, LoggingModule, LoggingModuleOptions, SyncLogComponent, SyncLogMessage, SyncLoggingService, SyncLoggingServiceStub, TraceSyncLogMessage, WarnSyncLogMessage };
//# sourceMappingURL=fitforce-logging.js.map
